"use client";
export { default as TabsTab } from "./Tab.js";
export { default as TabsList } from "./TabList.js";
export { default as TabsPanel } from "./TabPanel.js";
export { default as Tabs } from "./Tabs.js";
//# sourceMappingURL=index.js.map